import UEditor from './ueditor.vue';

const MyUEditor = {
  install: (Vue: any) => {
    Vue.component('MyUEditor', UEditor);
  },
};

export default MyUEditor;
